import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adminDashboardDetailsApi } from "../../../utils/ApiEndpointFunctions";
import Spinwheel from "../../common/Spinwheel";
// import DashboardCommonCard from "../../common/Cards/DashboardCommonCard";
// import TopPerformerCard from "../../common/Cards/TopPerformerCard";
import { useAdminContext } from "../../../context/adminContext";
import { useNavigate } from "react-router-dom";
import MetricCard from "./components/MetricCard";
import BusOperatorEarningChart from "./components/BusOperatorEarningChart";

export default function BusOperatorDashboard() {
  const [loader, setLoader] = useState(false)
  const [details, setDetails] = useState({})
  const { setAdminDetail, adminDetail } = useAdminContext();
  const navigate = useNavigate()

  const getDashboardDetails = async () => {
    try {
      setLoader(true);
      const res = await adminDashboardDetailsApi();
      setDetails(res?.data?.data);
      setLoader(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      setLoader(false);
    }
  }

  // useEffect(() => {
  //   if (adminDetail?.role === "superAdmin") {
  //     getDashboardDetails();
  //   } else {
  //     navigate("/partners?type=all")
  //   }

  // }, [adminDetail?.role])

  const metrics = [
    {
      label: "Bus Operators Application",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Reject Bus Operators",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Routes",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Bus Operators",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Bus",
      value: 0,
      background: "#E3F5FF",
    },
    {
      label: "Active Bus",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Trips",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Bookings",
      value: 0,

      background: "#E3F5FF",
    },
    {
      label: "Total Tickets",
      value: 0,

      background: "#E5ECF6",
    },
    {
      label: "Total Cancel Tickets",
      value: 0,
      background: "#E3F5FF",
    },
  ]


  return (
    <>
      <div className="main-content">

        <div className="container-fluid ">
          {
            loader ? <Spinwheel /> :
              <>
                <div className="mt-2 g-4 card rounded-2">


                  <div className="row">
                    <BusOperatorEarningChart />
                  </div>

                  <div className="metric_row">

                    {metrics.map((metric, index) => (
                      <MetricCard
                        key={index}
                        label={metric.label}
                        value={metric.value}
                        background={metric.background}
                      />
                    ))}

                  </div>
                </div>
              </>
          }

        </div>
      </div>
    </>
  );
}
